const APPLICATION_SETTINGS = {
  LOADING_APPLICATION_SETTINGS: "LOADING_APPLICATION_SETTINGS",
  CREATE_APPLICATION_SETTINGS: "CREATE_APPLICATION_SETTINGS",
  UPDATE_APPLICATION_SETTINGS: "UPDATE_APPLICATION_SETTINGS",
  SHOW_APPLICATION_SETTINGS: "SHOW_APPLICATION_SETTINGS",
  UPDATING_APPLICATION_SETTINGS: "UPDATING",
  ENHANCE_APPLICATION_SETTINGS: "ENHANCE_APPLICATION_SETTINGS",
};
export default APPLICATION_SETTINGS;
